import {ViewOptions} from 'backbone';

import {assert} from 'Asserts';
import AaSequence from 'molbio/aa-sequences/AaSequence';
import AaSequenceActions from 'molbio/aa-sequences/AaSequenceActions';
import {ProteinUpdateData} from 'molbio/aa-sequences/AaSequenceDAO';
import BasicInformationPanelView from 'toolbar/shared/BasicInformationPanelView';

class ProteinInformationPanelView extends BasicInformationPanelView<AaSequence> {
  constructor(...args: Array<ViewOptions<AaSequence>>) {
    super(...args);
    this.saveModel = this.saveModel.bind(this);
    this.deleteModel = this.deleteModel.bind(this);
    this.getDownloadInfo = this.getDownloadInfo.bind(this);
  }

  override saveModel(data: ProteinUpdateData): void {
    AaSequenceActions.update(this.model.id, data, {success: this.onSaveSuccess});
  }

  deleteModel(): void {
    AaSequenceActions.delete(this.model.id, {success: this.onDeleteSuccess});
  }

  getDownloadInfo(): Array<{url: string; title: string}> {
    const editUrl = this.model.editURL();
    assert(editUrl.slice(-5) === '/edit', 'Expected edit URL to end with /edit.');
    return [
      {
        url: editUrl.replace(/\/edit$/, '.fasta'),
        title: 'FASTA (.fasta)',
      },
      {
        url: editUrl.replace(/\/edit$/, '.gp'),
        title: 'GenPept (.gp)',
      },
    ];
  }
}

export default ProteinInformationPanelView;
